import Login from './StaffLogin-view';

export default Login;
